export default "__VITE_ASSET__AzNNzEBJ__"